import type { LoginRequest } from '@jq4race/shared';

import type { AuthRepository } from '../domain/ports/auth-repository';
import type { SessionFactory } from './ports/session-factory';
import { loginUseCase } from './use-cases/login.use-case';

interface AuthServicesDeps {
  authRepository: AuthRepository;
  createSession: SessionFactory;
}

export function createAuthServices(deps: AuthServicesDeps) {
  return {
    login: (input: LoginRequest) => loginUseCase(input, deps),
  };
}

export type AuthServices = ReturnType<typeof createAuthServices>;
